<div class="modal-body reg-view-setting-column-modal">
  <div class="invisible-input">
    <input ngbAutofocus />
  </div>
  <div class="close-button">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <i class="cc-icon cc-icon-close"></i>
    </button>
  </div>
  <h2 class="h2" i18n>Register View Column Settings</h2>

  <div class="settings" *ngIf="!loading && setting">
    <div i18n class="text-muted">Standard Columns (meta data)</div>
    <div class="reg-view-setting-column-container">
      <div class="reg-view-setting-column" *ngIf="template.isOrganisationTemplate">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showProject"
            class="styled"
            type="checkbox"
            name="showProject"
            [(ngModel)]="setting.metadata.showProject"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showProject" i18n>Project </label>
        </div>
      </div>
      <div class="reg-view-setting-column" *ngIf="template.isOrganisationTemplate">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showTeam"
            class="styled"
            type="checkbox"
            name="showTeam"
            [(ngModel)]="setting.metadata.showTeam"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showTeam" i18n>Team </label>
        </div>
      </div>
      <div class="reg-view-setting-column">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showCreatedBy"
            class="styled"
            type="checkbox"
            name="showCreatedBy"
            [(ngModel)]="setting.metadata.showCreatedBy"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showCreatedBy" i18n>Created By </label>
        </div>
      </div>
      <div class="reg-view-setting-column">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showCreatedOn"
            class="styled"
            type="checkbox"
            name="showCreatedOn"
            [(ngModel)]="setting.metadata.showCreatedOn"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showCreatedOn" i18n>Created Date </label>
        </div>
      </div>
      <div class="reg-view-setting-column">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showLastUpdatedOn"
            class="styled"
            type="checkbox"
            name="showLastUpdatedOn"
            [(ngModel)]="setting.metadata.showLastUpdatedOn"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showLastUpdatedOn" i18n>Last Updated </label>
        </div>
      </div>
      <div class="reg-view-setting-column">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showFormId"
            class="styled"
            type="checkbox"
            name="showFormId"
            [(ngModel)]="setting.metadata.showFormId"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showFormId" i18n>Form ID </label>
        </div>
      </div>
      <div class="reg-view-setting-column">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showDocVersion"
            class="styled"
            type="checkbox"
            name="showDocVersion"
            [(ngModel)]="setting.metadata.showDocVersion"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showDocVersion" i18n>Form Version </label>
        </div>
      </div>
      <div class="reg-view-setting-column" *ngIf="hasFormCounter">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showFormCounter"
            class="styled"
            type="checkbox"
            name="showFormCounter"
            [(ngModel)]="setting.metadata.showFormCounter"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showFormCounter" i18n
            >Automated Form Number
          </label>
        </div>
      </div>
      <div class="reg-view-setting-column" *ngIf="isWorkflow">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
          <input
            id="showWorkFlowStep"
            class="styled"
            type="checkbox"
            name="showWorkFlowStep"
            [(ngModel)]="setting.metadata.showWorkFlowStep"
            (change)="updateSaveButtonState()"
          />
          <label class="default-label checkbox-label" for="showWorkFlowStep" i18n>Workflow column </label>
        </div>
      </div>
    </div>

    <div class="mt-2 text-muted d-flex justify-content-between">
      <span i18n>Fields</span>
      <span i18n>Drag and drop to re-arrange</span>
    </div>

    <div class="reg-view-setting-column-container" [dragula]="dragulaBag" #fieldSettingsContainer>
      <!-- Select All Option -->
      <div class="reg-view-setting-column select-all">
        <div class="checkbox abc-checkbox abc-checkbox-primary form-check">
          <input
            id="selectAll"
            class="styled"
            type="checkbox"
            name="selectAll"
            data-test="select-all"
            [(ngModel)]="isSelectAllChecked"
            (change)="handleSelectAll()"
          />
          <label class="default-label checkbox-label checkbox-label-setting" for="selectAll">
            Select All
          </label>
        </div>
      </div>

      <ng-container *ngFor="let fieldSetting of setting.fields">
        <cc-register-view-setting-field
          *ngIf="!templateFields[fieldSetting.itemId]?.dependsOn?.fieldId"
          [fieldSetting]="fieldSetting"
          [fieldSettings]="setting.fields"
          [templateFields]="templateFields"
          [attr.data-field-id]="fieldSetting.itemId"
          [metadataList]="metadataList$"
          (onFieldSelectionChange)="setSelectAll()"
        >
        </cc-register-view-setting-field>
      </ng-container>
    </div>
  </div>
  <div class="pt-3 d-flex justify-content-center" *ngIf="!loading">
    <cc-popover placement="right" container="body" [disabled]="!isSaveButtonDisabled">
      <span content i18n> Register View Column Settings requires at least one field selected. </span>
      <button
        trigger
        type="button"
        class="btn btn-success save-button"
        i18n
        (click)="save()"
        [ccBusyButton]="loading"
        [disabled]="isSaveButtonDisabled"
      >
        Save changes
      </button>
    </cc-popover>
  </div>
  <div class="loading-spinner" *ngIf="loading">
    <i class="cc-icon cc-icon-spinner"></i>
  </div>
</div>
